import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VAutocomplete, {
    attrs: {
      "multiple": "",
      "items": _vm.options,
      "loading": _vm.loading,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "text",
      "item-value": "value",
      "hide-details": "",
      "label": _vm.label,
      "data-cy": _vm.dataCy
    },
    model: {
      value: _vm.selectedValues,
      callback: function ($$v) {
        _vm.selectedValues = $$v;
      },
      expression: "selectedValues"
    }
  })], 1)], 1), _c('draggable', {
    attrs: {
      "handle": ".handle .fa-grip-vertical"
    },
    on: {
      "start": function ($event) {
        _vm.isDragging = true;
      },
      "end": function ($event) {
        _vm.isDragging = false;
      }
    },
    model: {
      value: _vm.selectedValues,
      callback: function ($$v) {
        _vm.selectedValues = $$v;
      },
      expression: "selectedValues"
    }
  }, _vm._l(_vm.selectedValues, function (item, index) {
    return _c(VRow, {
      key: item,
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, [_c(VTextField, {
      staticClass: "handle",
      attrs: {
        "value": _vm.getOptionLabel(item),
        "readonly": "",
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "",
        "prepend-icon": "fal fa-grip-vertical"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "auto"
      }
    }, [_c(VBtn, {
      attrs: {
        "icon": ""
      },
      on: {
        "click": () => _vm.removeItem(index)
      }
    }, [_c(VIcon, [_vm._v("fal fa-trash")])], 1)], 1)], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };